import React from "react";
import Modal from "react-bootstrap/Modal";

const ManagerModal = ({
  show,
  onClose,
  managerName,
  setManagerName,
  managerModalError,
  onSubmit,
  disableSubmit
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Manager</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
            Manager Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={managerName}
            onChange={(e) => setManagerName(e.target.value)}
            placeholder="Enter manager name"
          />

          {managerModalError && (
            <div className="error text-danger mt-1">{managerModalError}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManagerModal;
